import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Airportcabserviceinmumbai() {



  const cardData =
  {
    keyword: 'Airport Cab Services in Mumbai',
    heading: 'Aaryan Travels: Airport Cab Services in Mumbai',
    headingDescription: 'Aaryan Travels offers reliable Airport Cab Services in Mumbai for smooth and punctual transfers to and from Chhatrapati Shivaji Maharaj International Airport (T1 & T2). Whether you’re a frequent business traveler, tourist, or family passenger, our fleet of hatchbacks, sedans, SUVs, and luxury cabs ensures a comfortable and stress-free airport ride. With real-time flight tracking, professional chauffeurs, and 24/7 availability, we guarantee timely pickups and drop-offs across South Mumbai, Bandra, Andheri, Navi Mumbai, and Thane. Aaryan Travels provides transparent fares, doorstep pickup, and luggage assistance, making airport travel effortless and dependable.',

    top: 'Top Places to Visit in Mumbai with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Built in 1924 overlooking the Arabian Sea, the Gateway of India is Mumbai’s most iconic monument. It once served as a ceremonial entrance during British rule. Visitors enjoy ferry rides to Elephanta Caves and the scenic coastal breeze. Street vendors, photographers, and lively crowds surround the plaza. The Gateway of India is Mumbai’s proud symbol of history and heritage."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously nicknamed the Queen’s Necklace, is a 3.6 km-long boulevard curving along the shoreline. People gather here for sunset walks, ocean breeze, and roadside chai. At night, the streetlights resemble a glowing necklace. Joggers, couples, and photographers frequent this spot daily. Marine Drive is Mumbai’s timeless seaside escape."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST is a UNESCO World Heritage Site and one of India’s most beautiful railway stations. Built in 1887, it features Victorian Gothic architecture with domes, stained-glass windows, and intricate carvings. Despite its historical charm, it functions as one of the busiest stations in the country. Illuminated at night, it looks like a royal palace. CST is Mumbai’s iconic blend of art and activity."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beach, known for its vibrant atmosphere and local street food like pav bhaji and bhel puri. Families enjoy camel rides and children play in the sands. Bollywood celebrities often visit the nearby area. Sunset scenes create a lively and colorful vibe. Juhu Beach is Mumbai’s joyful seaside hangout."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a 15th-century mosque and tomb located on a small islet connected by a narrow pathway. Surrounded by the sea on all sides, it appears to float during high tide. Devotees of all faiths visit to seek blessings and listen to qawwali music. Its white marble structure offers peace and serenity. Haji Ali is Mumbai’s spiritual gem of unity."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, these rock-cut caves date back to the 5th century and are dedicated to Lord Shiva. The massive Trimurti sculpture is the main highlight. Visitors take ferries from the Gateway of India to reach the site. Surrounded by greenery and history, it offers both adventure and culture. Elephanta Caves are Mumbai’s ancient world carved in stone."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered Hindu temples dedicated to Lord Ganesha. Devotees, including celebrities and politicians, queue up daily for blessings. The gold-plated dome and beautifully carved idol uplift the soul. Special prayers on Tuesdays attract huge crowds. Siddhivinayak is Mumbai’s divine hub of devotion."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a cable-stayed engineering marvel connecting South Mumbai to the suburbs. Driving on it offers stunning sea views and skyline panoramas. At night, the illuminated bridge looks futuristic and majestic. It significantly reduces travel time while adding glamour to the city’s infrastructure. The Sea Link is Mumbai’s modern icon of progress."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a bustling street market known for budget shopping, fashion accessories, antiques, and souvenirs. Iconic cafes like Leopold Café and Café Mondegar add retro charm. Tourists love bargaining and exploring vibrant stalls. It’s the perfect mix of culture, food, and fashion. Colaba Causeway is Mumbai’s colorful shopping paradise."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is one of the largest urban forests in the world, offering nature trails, wildlife safaris, and ancient Kanheri Caves. Visitors enjoy cycling, trekking, and toy train rides. Leopards, deer, and birds are often spotted. The park provides fresh air and greenery just minutes away from city life. SGNP is Mumbai’s natural haven of adventure."
  }
],


"services": [
  {
    "name": "Airport Cab Services in Mumbai",
    "description": "Our Airport Cab Services in Mumbai provide reliable and timely transportation to and from all major airports in the city. Designed for business travelers, tourists, and locals alike, we ensure a smooth travel experience with professional chauffeurs, comfortable vehicles, and real-time flight tracking to adjust pickups or drop-offs as needed. Whether you need a quick airport drop or a pickup from the terminal, our service guarantees punctuality and convenience around the clock."
  },
  {
    "name": "Mumbai Airport Taxi",
    "description": "Mumbai Airport Taxi service offers hassle-free, door-to-door transfers between your location and Mumbai’s airports. Our fleet includes sedans, SUVs, and luxury cars driven by courteous and experienced drivers. With 24x7 availability, clean vehicles, and easy online booking, we cater to both individual travelers and corporate clients needing dependable airport transportation."
  },
  {
    "name": "Airport Pickup Cab Mumbai",
    "description": "Experience stress-free airport pickups in Mumbai with our dedicated Airport Pickup Cab service. Our drivers monitor your flight status to ensure timely arrival, help with luggage, and provide a comfortable ride to your destination. Available for solo travelers, families, and business groups, we focus on punctuality, safety, and excellent customer service to start your journey on the right note."
  },
  {
    "name": "Airport Drop Cab Mumbai",
    "description": "Our Airport Drop Cab Mumbai service guarantees prompt and reliable rides from your home or office to the airport. Avoid last-minute rushes and enjoy a comfortable, smooth journey with professional chauffeurs who understand the importance of timely airport arrivals. Flexible booking options and real-time tracking provide peace of mind for travelers of all kinds."
  },
  {
    "name": "Chauffeur Airport Taxi Mumbai",
    "description": "For a premium travel experience, choose our Chauffeur Airport Taxi Mumbai service. Professional drivers provide courteous and discreet service, ensuring your journey is relaxing and efficient. Ideal for business executives, VIPs, and anyone valuing comfort and professionalism, our chauffeur-driven airport transfers offer a seamless blend of luxury and punctuality."
  },
  {
    "name": "Luxury Airport Cab Mumbai",
    "description": "Travel in style with our Luxury Airport Cab Mumbai service, featuring high-end sedans and SUVs equipped with modern amenities such as leather interiors, Wi-Fi, and climate control. Perfect for VIP clients, corporate travelers, and special occasions, this service combines luxury with the reliability needed for timely airport transfers."
  },
  {
    "name": "Affordable Airport Cab Mumbai",
    "description": "Affordable Airport Cab Mumbai offers budget-friendly airport transfers without compromising quality or reliability. Ideal for cost-conscious travelers, our service provides clean, safe vehicles and professional drivers, ensuring you reach your airport on time and without stress. Transparent pricing and no hidden charges make this service a preferred choice among frequent flyers."
  },
  {
    "name": "Corporate Airport Transfer Mumbai",
    "description": "Our Corporate Airport Transfer Mumbai service caters to businesses requiring dependable and professional transportation for employees and clients. We offer customized solutions including monthly contracts, priority bookings, and premium vehicles to ensure smooth airport commutes. Our drivers are trained in corporate etiquette, delivering discreet and punctual service every time."
  },
  {
    "name": "Online Airport Cab Booking Mumbai",
    "description": "Online Airport Cab Booking Mumbai allows you to schedule your airport transfers quickly and conveniently from any device. With instant confirmation, fare estimates, and real-time ride tracking, this digital solution streamlines your travel plans. Whether booking for yourself or multiple employees, our platform makes airport transportation easy and efficient."
  },
  {
    "name": "Best Airport Taxi Mumbai",
    "description": "Recognized as the Best Airport Taxi Mumbai service, we pride ourselves on reliability, punctuality, and excellent customer care. Our extensive fleet, professional chauffeurs, and 24x7 availability ensure that every airport transfer exceeds expectations. Choose us for a consistently superior travel experience to and from Mumbai airports."
  },
  {
    "name": "Airport Sedan Rental Mumbai",
    "description": "Airport Sedan Rental Mumbai offers sleek, comfortable sedans ideal for solo travelers, couples, and small groups. Our sedans come equipped with air conditioning, ample luggage space, and well-trained drivers. Flexible rental durations and easy booking options make this service perfect for both short airport rides and longer transfers."
  },
  {
    "name": "Airport SUV Rental Mumbai",
    "description": "Our Airport SUV Rental Mumbai service provides spacious and robust vehicles suitable for larger groups or travelers with extra luggage. With comfortable seating, enhanced safety features, and experienced drivers, our SUVs ensure a smooth and luxurious airport transfer experience every time."
  },
  {
    "name": "24x7 Airport Taxi Mumbai",
    "description": "Mumbai’s 24x7 Airport Taxi service guarantees you never miss a flight, no matter the hour. Available round-the-clock with prompt pickups and drop-offs, this service is tailored for early morning departures, late-night arrivals, and all flights in between. Depend on us for safe and timely airport transport any time of day or night."
  },
  {
    "name": "Airport Transfer Services Mumbai",
    "description": "Our comprehensive Airport Transfer Services Mumbai cover pickups, drops, and inter-terminal transfers across all Mumbai airports. With options ranging from economy to luxury vehicles, we cater to various traveler preferences. Professional chauffeurs, real-time tracking, and excellent customer support ensure a hassle-free travel experience."
  },
  {
    "name": "Premium Airport Cab Mumbai",
    "description": "Premium Airport Cab Mumbai provides top-tier airport transportation with a focus on luxury, comfort, and professionalism. Featuring high-end vehicles and experienced chauffeurs, this service is perfect for VIP travelers, corporate clients, and special events, delivering an exceptional airport transfer experience every time."
  }
],
"tableData": [
  ["Airport Cab Services in Mumbai", "Mumbai Airport Taxi"],
  ["Airport Pickup Cab Mumbai", "Airport Drop Cab Mumbai"],
  ["Chauffeur Airport Taxi Mumbai", "Luxury Airport Cab Mumbai"],
  ["Affordable Airport Cab Mumbai", "Corporate Airport Transfer Mumbai"],
  ["Online Airport Cab Booking Mumbai", "Best Airport Taxi Mumbai"],
  ["Airport Sedan Rental Mumbai", "Airport SUV Rental Mumbai"],
  ["24x7 Airport Taxi Mumbai", "Airport Transfer Services Mumbai"],
  ["Premium Airport Cab Mumbai", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Reliable Airport Cab Services in Mumbai",
    "WhyChoosedescription": "Aaryan Travels offers timely and comfortable airport cab services to and from all major airports in Mumbai."
  },
  {
    "WhyChooseheading": "Punctual Pickup and Drop for Stress-Free Travel",
    "WhyChoosedescription": "Our drivers ensure on-time pickups and drop-offs so you never miss your flight."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained to provide you with a pleasant journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Airport Routes",
    "WhyChoosedescription": "Our professional drivers know Mumbai’s airport routes well to ensure efficient and smooth rides."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront pricing that includes fuel, tolls, and driver allowances for hassle-free billing."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Booking Assistance",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for One-Way or Round Trips",
    "WhyChoosedescription": "Choose from one-way rides or round trips tailored to your schedule and convenience."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers to suit your luggage and comfort needs."
  }
]


































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer airport cab services in Mumbai?',
    answer: 'Yes, Aaryan Travels provides reliable and convenient airport cab services in Mumbai, ensuring timely pickups and drop-offs.',
  },
  {
    question: 'How can I book airport cab services in Mumbai with Aaryan Travels?',
    answer: 'You can easily book airport cabs through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for airport cab services in Mumbai?',
    answer: 'Aaryan Travels offers a variety of vehicles including sedans, SUVs, and premium cars suitable for airport transfers.',
  },
  {
    question: 'Are your drivers experienced with Mumbai airport routes?',
    answer: 'Absolutely. Our drivers are professional, licensed, and well-acquainted with all Mumbai airport routes to ensure smooth travel.',
  },
  {
    question: 'Can I book airport cabs for both arrivals and departures in Mumbai?',
    answer: 'Yes, we provide airport cab services for both pickups from and drop-offs to Mumbai airports.',
  },
  {
    question: 'Is airport cab service available 24x7 in Mumbai?',
    answer: 'Yes, Aaryan Travels offers round-the-clock airport cab services in Mumbai to accommodate all flight timings.',
  },
  {
    question: 'Are safety and hygiene protocols followed for airport cab services?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety protocols to protect passengers.',
  },
  {
    question: 'What payment options are accepted for airport cab services in Mumbai?',
    answer: 'We accept cash, digital wallets, UPI, and card payments for your convenience.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for airport cab bookings in Mumbai?',
    answer: 'Yes, you can specify your preferred pickup and drop-off points within Mumbai and nearby areas.',
  },
  {
    question: 'Is there customer support available during airport cab rides?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Mehta',
    feedback: 'Aaryan Travels’ airport cab service in Mumbai was punctual and the ride was comfortable. Highly recommend!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Kapoor',
    feedback: 'Smooth and hassle-free airport transfer experience with Aaryan Travels in Mumbai.',
    rating: 5,
  },
];




















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];







const airportCabServicesMumbaiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Airport Cab Services in Mumbai",
  "description": "Aaryan Travels provides reliable and affordable airport cab services in Mumbai including airport pickups, drop-offs, luxury and corporate transfers available 24x7.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Mumbai"
  },
  "serviceType": "Airport Cab Services",
  "keywords": "Airport Cab Services in Mumbai, Mumbai Airport Taxi, Airport Pickup Cab Mumbai, Airport Drop Cab Mumbai, Chauffeur Airport Taxi Mumbai, Luxury Airport Cab Mumbai, Affordable Airport Cab Mumbai, Corporate Airport Transfer Mumbai, Online Airport Cab Booking Mumbai, Best Airport Taxi Mumbai, Airport Sedan Rental Mumbai, Airport SUV Rental Mumbai, 24x7 Airport Taxi Mumbai, Airport Transfer Services Mumbai, Premium Airport Cab Mumbai"
};








  return (
    <div>
<Helmet>
  <title>Airport Cab Services in Mumbai | Reliable Airport Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Get affordable and chauffeur-driven airport cab services in Mumbai with Aaryan Travels. Book online for airport pickups, drop-offs, and luxury transfers available 24x7."
  />
  <meta
    name="keywords"
    content="Airport Cab Services in Mumbai, Mumbai Airport Taxi, Airport Pickup Cab Mumbai, Airport Drop Cab Mumbai, Chauffeur Airport Taxi Mumbai, Luxury Airport Cab Mumbai, Affordable Airport Cab Mumbai, Corporate Airport Transfer Mumbai, Online Airport Cab Booking Mumbai, Best Airport Taxi Mumbai, Airport Sedan Rental Mumbai, Airport SUV Rental Mumbai, 24x7 Airport Taxi Mumbai, Airport Transfer Services Mumbai, Premium Airport Cab Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(airportCabServicesMumbaiSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/50.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                   <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Airportcabserviceinmumbai;